module.exports = __webpack_public_path__ + "img/draw_bg.2a0aa2ab.jpg";